function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useEffect } from "react";
import { Form, Input, Button, Alert, DatePicker } from "antd";
import Common from "../includes/Common";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var NewAppointment = function NewAppointment(_ref) {
  var handler = _ref.handler;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFormProcessing = _useState2[0],
    setIsFormProcessing = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    errorMessage = _useState4[0],
    setErrorMessage = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    successMessage = _useState6[0],
    setSuccessMessage = _useState6[1];
  var onFinish = function onFinish(values) {
    setIsFormProcessing(true);
    setSuccessMessage('');
    setErrorMessage('');
    axios.post(Common.baseApiUrl + 'setappointment', {
      patient_id: values.patient_id,
      reason: values.reason,
      date: values.date,
      user_id: Common.currentUser.id
    }).then(function (response) {
      if (response.data.status == 200) {
        setSuccessMessage("Rendez-vous enregistré avec succès");
        handler();
      } else {
        setErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      setErrorMessage("Une erreur est survenue");
    })["finally"](function () {
      setIsFormProcessing(false);
    });
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [errorMessage.length != 0 && /*#__PURE__*/_jsx(Alert, {
      message: errorMessage,
      type: "error",
      banner: true
    }), successMessage.length != 0 && /*#__PURE__*/_jsx(Alert, {
      message: successMessage,
      type: "success",
      banner: true
    }), /*#__PURE__*/_jsx("h5", {
      children: "NOUVEAU RENDEZ-VOUS"
    }), /*#__PURE__*/_jsxs(Form, {
      style: {
        color: '#EEE'
      },
      onFinish: onFinish,
      layout: "vertical",
      children: [/*#__PURE__*/_jsx(Form.Item, {
        name: "patient_id",
        label: "ID patient/T\xE9l\xE9phone",
        rules: [{
          required: true,
          message: 'Ce champs est obligatoire'
        }],
        children: /*#__PURE__*/_jsx(Input, {
          placeholder: "Entrez ID patient ou numero de t\xE9l\xE9phone"
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "reason",
        label: "Motif",
        rules: [{
          required: true,
          message: 'Ce champs est obligatoire'
        }],
        children: /*#__PURE__*/_jsx(Input, {
          placeholder: "Entrez le motif ici"
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "date",
        label: "Date",
        rules: [{
          required: true,
          message: 'Ce champs est obligatoire'
        }],
        children: /*#__PURE__*/_jsx(DatePicker, {
          showTime: true,
          placeholder: "Choisir une date"
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Button, {
          loading: isFormProcessing,
          type: "default",
          htmlType: "submit",
          children: "Valider"
        })
      })]
    })]
  });
};
export default NewAppointment;